<template>
  <span>
    <b-button
      @click.prevent="
        e => {
          e.target.blur();
          $bvModal.show('add-from-stock-modal');
        }
      "
      class="mr-1"
      >Agregar desde linea</b-button
    >
    <b-modal id="add-from-stock-modal" size="xl">
      <stock-list
        :column_display="column_display"
        :columns="columns"
        :filterable="filterable"
        :headings="headings"
        :url="url"
        @select-row="rowClick($event)"
        @on-loading="loading = $event"
      />
    </b-modal>

    <b-modal
      v-model="modalAddStock"
      size="sn"
      @hide="hideModal"
      title="Ingresar a proceso"
    >
      <b-row>
        <b-col cols="6">
          <p>
            Producto: {{ info.product_name }}
            <br />
            Código: {{ info.product_code }}
            <br />
            Tipo: {{ info.product_type }}
            <br />
            Lote:{{ info.lot }}
            <br />
            Área: {{ info.stock_area }}
            <br />
            Recipiente: {{ info.container }}
            <br />
          </p>

          <p>
            <b>Cantidad inicial: {{ info.quantity }}</b>
            <br />
            <b>Cantidad restante: {{ residuaryQuantity }}</b>
          </p>
          <p>
            <b>KN inicial: {{ info.net_kilograms }}</b>
            <br />
            <b>KN restante: {{ residuaryNetWeight }}</b>
          </p>
          <p>
            <b>KB inicial: {{ info.gross_kilograms }}</b>
            <br />
            <b>KB restante: {{ residuaryGrosskilograms }}</b>
          </p>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Tipo de ingreso">
            <b-form-radio-group
              v-model="$v.type_income.$model"
              :state="$v.type_income.$dirty ? !$v.type_income.$error : null"
              :options="options"
              name="radio-inline"
            ></b-form-radio-group>
          </b-form-group>
          <div v-if="type_income == 1">
            <b-form-group>
              <label class="text-uppercase font-weight-bold"
                >Ingrese Cantidad</label
              >
              <b-form-input
                v-model="$v.quantity_select.$model"
                :state="
                  $v.quantity_select.$dirty ? !$v.quantity_select.$error : null
                "
                type="text"
                v-on:keyup="inputSoloNumero"
              >
              </b-form-input>
            </b-form-group>

            <b-form-group>
              <label class="text-uppercase font-weight-bold" for="name"
                >Peso Neto</label
              >
              <b-form-input disabled :value="netWeight" type="number">
              </b-form-input>
            </b-form-group>

            <b-form-group>
              <label class="text-uppercase font-weight-bold" for="name"
                >Peso Brutos</label
              >
              <b-form-input disabled :value="gross_kilograms" type="number">
              </b-form-input>
            </b-form-group>
          </div>
        </b-col>
      </b-row>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            @click.prevent="onSubmit()"
            class="float-right ml-1"
            >Guardar<!-- /imprimir -->
            <b-spinner v-if="loading" class="float-right" small />
          </b-button>
          <!-- <b-button class="float-right ml-1" variant="primary">Guardar</b-button> -->
          <b-button class="float-right ml-1" @click="hideModal"
            >Cancelar
          </b-button>
        </div>
      </template>
    </b-modal>
  </span>
</template>

<script>
import StockList from "../../ServerFilterableTable";

import {
  decimal,
  integer,
  required,
  requiredIf
} from "vuelidate/lib/validators";

export default {
  name: "AddFromStock",
  components: {
    StockList
  },
  data() {
    return {
      quantity_select: "",
      type_income: "0",
      options: [
        { text: "Total", value: "0" },
        { text: "Parcial", value: "1" }
      ],
      loading: false,
      modalAddStock: false,
      info: {
        product_name: "",
        lot: "",
        product_code: "",
        number: "",
        quantity: "",
        container: "",
        net_kilograms: "",
        gross_kilograms: "",
        stock_area: "",
        product_type: "",
        content_id: "",
        container_material_weight: "",
        selling_unit: ""
      },
      column_display: {
        product_family: "not_desktop",
        product_fruit: "not_desktop",
        lot: "",
        product_code: "",
        product: "",
        number: "",
        quantity: "",
        container: "",
        creation_date: "not_desktop",
        net_kilograms: "",
        gross_kilograms: "",
        position: "not_desktop"
      },
      columns: [
        "product_family",
        "product_fruit",
        "product_code",
        "product",
        "product_type.name",
        "lot",
        "stock_area",
        "number",
        "container",
        "quantity",
        "creation_date",
        "net_kilograms"
      ],
      filterable: [
        "product",
        "product_code",
        "product_type.name",
        "lot",
        "container",
        "creation_date",
        "stock_area",
        "number",
        "product_fruit",
        "product_family"
      ],
      headings: {
        product_family: "Familia",
        product_fruit: "Fruta",
        "product_type.name": "Tipo",
        lot: "Lote",
        number: "Número",
        product_code: "Código",
        product: "Producto",
        quantity: "Cantidad",
        container: "Recipiente",
        creation_date: "fecha",
        net_kilograms: "KN",
        gross_kilograms: "KB",
        stock_area: "Área"
      }
    };
  },
  watch: {
    type_income(val) {
      this.quantity_select = "";
      //Parcial
      if (val == 1) {
      }
      //Total
      if (val == 0) {
      }
    },
    quantity_select: {
      handler(val) {
        if (val > this.info.quantity) {
          this.quantity_select = "";
          this.$toast.info(
            "La cantidad ingresada supera la cantidad disponible",
            ""
          );
        }
      }
    }
  },
  methods: {
    onSubmit(evt) {
      if (this.$v.$invalid == true) {
        this.$toast.info("Campos restantes o inválidos en el formulario", "");
      } else {
        if (
          parseInt(this.quantity_select) == parseInt(this.info.quantity) &&
          this.type_income == 1
        ) {
          this.$toast.info(
            "Estas ingresando la cantidad total disponible, utiliza Tipo de ingreso (Total) por favor.",
            ""
          );
        } else {
          let data = {
            quantity:
              this.type_income == 0 ? this.info.quantity : this.quantity_select,
            net_kilograms:
              this.type_income == 0 ? this.info.net_kilograms : this.netWeight,
            gross_kilograms:
              this.type_income == 0
                ? this.info.gross_kilograms
                : this.gross_kilograms,
            content_id: this.info.content_id,
            type_income: this.type_income
          };

          if (this.type_income == 0) {
            this.modalAddStock = false;
            this.$emit("row-click", data);
          }

          if (this.type_income == 1) {
            if (
              parseInt(this.quantity_select) <= parseInt(this.info.quantity) &&
              parseInt(this.quantity_select) != 0
            ) {
              this.modalAddStock = false;
              this.$emit("row-click", data);
              this.quantity_select = "";
              this.type_income = "0";
            } else {
              this.$toast.info("El campo cantidad no puede ser cero", "");
            }
          }
        }
      }
    },
    hideModal() {
      this.modalAddStock = false;
      this.quantity_select = "";
      this.type_income = "0";
    },
    rowClick(evt) {
      this.info.product_name = evt.product_name;
      this.info.lot = evt.lot;
      this.info.product_code = evt.product_code;
      this.info.number = evt.number;
      this.info.quantity = evt.quantity;
      this.info.container = evt.container;
      this.info.net_kilograms = evt.net_kilograms;
      this.info.gross_kilograms = evt.gross_kilograms;
      this.info.container_material_weight = evt.container_material_weight;
      this.info.stock_area = evt.stock_area;
      this.info.product_type = evt.product_type.name;
      this.info.content_id = evt.id;
      this.modalAddStock = true;
    },
    inputSoloNumero(event) {
      event.target.value = event.target.value.replace(/[^0-9]/, "");
    }
  },
  computed: {
    stock_area_filter_constructor() {
      let filter = this.$route.params;
      filter = !_.isEmpty(filter)
        ? filter.process_type_complete.stockarea_set.map(e => e.id).join(",")
        : "";
      return "stock_area=" + filter;
    },
    url() {
      return (
        "/bagno/content-process-stock/?" + this.stock_area_filter_constructor
      );
    },
    netWeight() {
      return (
        (this.quantity_select * this.info.net_kilograms) /
        this.info.quantity
      ).toFixed(2);
    },
    gross_kilograms() {
      return (
        (this.quantity_select * this.info.gross_kilograms) /
        this.info.quantity
      ).toFixed(2);
    },
    residuaryQuantity() {
      if (this.type_income == 0) {
        return 0;
      }
      if (this.type_income == 1) {
        return Math.abs(this.info.quantity - this.quantity_select);
      }
    },
    residuaryNetWeight() {
      if (this.type_income == 0) {
        return 0;
      }
      if (this.type_income == 1) {
        return Math.abs(this.info.net_kilograms - this.netWeight).toFixed(2);
      }
    },
    residuaryGrosskilograms() {
      if (this.type_income == 0) {
        return 0;
      }
      if (this.type_income == 1) {
        return Math.abs(
          this.info.gross_kilograms - this.gross_kilograms
        ).toFixed(2);
      }
    }
  },
  validations: {
    type_income: { required, integer },
    quantity_select: {
      required: requiredIf(function() {
        return this.type_income === "1";
      })
    }
  }
};
</script>

<style scoped></style>
